<template>
  <section class="info-general">
    <h4>{{ title }}</h4>

    <!-- Sistema de filtros (oculto cuando la vista se fija a una categoría) -->
    <div v-if="!category" class="filter-tabs">
      <button v-for="filter in filters" :key="filter.key" @click="activeFilter = filter.key"
        :class="['filter-tab', { 'active': activeFilter === filter.key }]">
        {{ filter.label }}
      </button>
    </div>

    <!-- Grid de PDFs filtrados -->
    <div class="pdf-grid-filtered">
      <PdfCard v-for="(pdf, index) in filteredPdfs" :key="index" :title="pdf.title" :category="pdf.category"
        :pdfUrl="pdf.url" />
    </div>
  </section>
</template>

<script>
import PdfCard from "./PdfCard.vue";

export default {
  components: {
    PdfCard,
  },
  props: {
    title: {
      type: String,
      default: 'Contenido de Valor',
    },
    // Si se define, muestra solo esa categoría y oculta los filtros
    category: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      activeFilter: this.category || 'todos',
      filters: [
        { key: 'todos', label: 'Todos' },
        { key: 'fns', label: 'Fiesta del Sol' },
        { key: 'salud-mental', label: 'Salud Mental' },
        { key: 'ironman', label: 'Ironman' },
        { key: 'contenido-valor', label: 'Contenido de Valor' },
        { key: 'boletines-epidemiologicos', label: 'Boletines Epidemiológicos' }
      ],

      allPdfs: [
        // Salud Mental
        { title: "Salud Mental y Deporte", url: "https://drive.google.com/file/d/1T2gQpeOV7KSi31nrGQMHhdiG2v74wtDK/view?usp=drive_link", category: "salud-mental" },
        { title: "Plan General Provincial de Salud Mental", url: "/docs/PLAN GENERAL PROVINCIAL DE SALUD MENTAL.PDF", category: "salud-mental" },
        { title: "Resumen Salud Mental", url: "/docs/RESUMEN PSalud Mental_web.pdf", category: "salud-mental" },

        //FNS
        { title: "Salud Mental", url: "https://salud.sanjuan.gob.ar/docs/250326_salud-mental-y-af.pdf", category: "fns" },
        { title: "TOMÁ AGUA", url: "https://salud.sanjuan.gob.ar/docs/251122_fns-hidra.pdf", category: "fns" },
        { title: "Conoces los beneficios de hidratarse?", url: "https://salud.sanjuan.gob.ar/docs/251122_aguadigital.pdf", category: "fns" },
        { title: "Recomendaciones de actividad física", url: "https://salud.sanjuan.gob.ar/docs/250327_act-fisica.pdf", category: "fns" },

        // Ironman
        { title: "Salud Mental y AF", url: "https://salud.sanjuan.gob.ar/docs/250326_Salud Mental y AF.pdf", category: "ironman" },
        { title: "RCP", url: "https://salud.sanjuan.gob.ar/docs/250401_RCP.pdf", category: "ironman" },
        { title: "Act. Física", url: "https://salud.sanjuan.gob.ar/docs/250327_Act. Fisica.pdf", category: "ironman" },

        // Contenido de Valor
        { title: "Guía Servicios en Salud", url: "https://drive.google.com/file/d/11vF8sbsBpawENdkIzm-EfdE2rNSfVl8B/view?usp=drive_link", category: "contenido-valor" },
        { title: "Vivi activamente", url: "https://drive.google.com/file/d/1DGT19qJATZt6xeYvAVKVYUnUvR5BnLfT/view?usp=drive_link", category: "contenido-valor" },
        { title: "Consejos ante las altas temperaturas", url: "https://drive.google.com/file/d/1XkCtnFrOsjUzWZjvrE9T65tYxbjbWPcP/view?usp=drive_link", category: "contenido-valor" },
        { title: "Donar sangre es donar Vida", url: "https://drive.google.com/file/d/107Q9WoceUj3osMfPHFh1r3MR669bGD_P/view?usp=drive_link", category: "contenido-valor" },
        { title: "Acciones contra el mosquito", url: "https://drive.google.com/file/d/1BTJbfX90vdX-8cwOQ-TsCwzX5-s-gpLs/view?usp=drive_link", category: "contenido-valor" },
        { title: "Cuidado de la Mujer", url: "https://drive.google.com/file/d/1Rx5oCuZGYrDtSnzh305pOEIf4xPHwxDo/view?usp=drive_link", category: "contenido-valor" },
        { title: "Síndrome Urémico Hemolítico - Botulismo", url: "https://drive.google.com/file/d/1zcRWnMveqj1bmN1ssZW4Cpx473TEPbEC/view?usp=drive_link", category: "contenido-valor" },
        { title: "Triquinosis", url: "https://drive.google.com/file/d/1wyX0xhHAMadcYojoG42u3HqYPyp7lHPZ/view?usp=drive_link", category: "contenido-valor" },
        { title: "Picaduras de escorpión", url: "https://drive.google.com/file/d/1k7VpdJBrJ-7R9iQASvbyZ7vjfMDdX6j-/view?usp=drive_link", category: "contenido-valor" },
        { title: "Medidas de prevención de Meningitis", url: "https://drive.google.com/file/d/1hQTgNMLcj11UHCyG21zWQyrwyBwNPVa3/view?usp=drive_link", category: "contenido-valor" },
        { title: "Dengue - Viruela del mono", url: "https://drive.google.com/file/d/1vDiA1Ah48x0ku04fIX22HxB0eg_byDrp/view?usp=drive_link", category: "contenido-valor" },
        { title: "Beneficios de la Hidratación", url: "https://drive.google.com/file/d/1ZtNk4sMj68mVmKzg9cZT0UyRSqW4-Uz-/view?usp=drive_link", category: "contenido-valor" },
        { title: "Cuidados en las personas con Diabetes", url: "https://drive.google.com/file/d/1giEe7rDJTKjnAGQbOKgs6jTuKr1y3tz-/view?usp=drive_link", category: "contenido-valor" },
        { title: "Hipertensión", url: "https://drive.google.com/file/d/1Z9hZn-Ky_3CGc2GntrmKdBaTKqbh4URs/view?usp=drive_link", category: "contenido-valor" },
        { title: "Lepra - Tuberculosis", url: "https://drive.google.com/file/d/19smmpjOqL-phvA4xqp_0Rp9Qlvd5G4DY/view?usp=drive_link", category: "contenido-valor" },
        { title: "Riesgo Cardiovascular", url: "https://drive.google.com/file/d/1ABYl3FuLCQypZVyk26rUzFHaj3IvGTye/view?usp=drive_link", category: "contenido-valor" },
        { title: "Cepillado dental", url: "https://drive.google.com/file/d/1Ip5ZaXQYVmnquoZhpF5hZwuyse8jeqV3/view?usp=drive_link", category: "contenido-valor" },
        { title: "2 mil días - Razones para dar abrazos a tus hijos", url: "https://drive.google.com/file/d/12Xyw2uMv_h4lvlUk946I5XEZib4X7uNW/view?usp=drive_link", category: "contenido-valor" },
        { title: "Consejos útiles para celíacos", url: "https://drive.google.com/file/d/1dJAkRaqzfZ0Xq8j3bO46ov_ZxZNScUz8/view?usp=drive_link", category: "contenido-valor" },
        { title: "Trastorno del Espectro Autista", url: "https://drive.google.com/file/d/1A01a7U4oF25dySx4hQ96jv65jO7ir57o/view?usp=drive_link", category: "contenido-valor" },
        { title: "Discapacidad Infantojuvenil", url: "https://drive.google.com/file/d/1cyuUe9F5c-ghClWTOHjP2TYf7obabVBi/view?usp=drive_link", category: "contenido-valor" },
        { title: "Enfermedades Respiratorias", url: "https://drive.google.com/file/d/1HX1QtGesZCgLhyfz7wH94mW9TlQepUvT/view?usp=drive_link", category: "contenido-valor" },
        { title: "Prevención de intoxicación con Monóxido de carbono", url: "https://drive.google.com/file/d/1f2aYtdR7ts3NYIgAt8sGcg33DTv1pJTx/view?usp=drive_link", category: "contenido-valor" },
        { title: "Pediculosis", url: "https://drive.google.com/file/d/1ypsuE_AlwDCuN1s15-KASWN4duo2BIb0/view?usp=drive_link", category: "contenido-valor" },
        { title: "Prevención de suicidio", url: "https://drive.google.com/file/d/1M3lkkhjIfazyO7-bhHYHER2pLWalbSSZ/view?usp=drive_link", category: "contenido-valor" },
        { title: "Salud Bucal y Deporte", url: "https://drive.google.com/file/d/1nRtGB2BGNRHFqJwYFmnKOATgtWRvw8z0/view?usp=drive_link", category: "contenido-valor" },
        { title: "Varicela", url: "/docs/240618_varicela.pdf", category: "contenido-valor" },

        // Boletines Epidemiológicos
        { title: "Boletín Epidemiológico - Septiembre 2026", url: "/docs/boletin-epidemiologico-septiembre-2026.pdf", category: "boletines-epidemiologicos" },
        { title: "Boletín Epidemiológico - Agosto 2026", url: "/docs/boletin-epidemiologico-agosto-2026.pdf", category: "boletines-epidemiologicos" },
        { title: "Boletín Epidemiológico - Julio 2026", url: "/docs/boletin-epidemiologico-julio-2026.pdf", category: "boletines-epidemiologicos" },
        { title: "Boletín Epidemiológico - Junio 2026", url: "/docs/boletin-epidemiologico-junio-2026.pdf", category: "boletines-epidemiologicos" },
        { title: "Boletín Epidemiológico - Marzo 2026", url: "/docs/boletin-epidemiologico-marzo-2026.pdf", category: "boletines-epidemiologicos" },
        { title: "Boletín Epidemiológico - Diciembre 2025", url: "https://salud.sanjuan.gob.ar/docs/boletin-epidemio_dic-25_n-4.pdf", category: "boletines-epidemiologicos" },
        { title: "Boletín Epidemiológico - Octubre 2025", url: "https://salud.sanjuan.gob.ar/docs/boletin-epidemio-octubre.pdf", category: "boletines-epidemiologicos" },
        { title: "Boletín Epidemiológico - Septiembre 2025", url: "https://salud.sanjuan.gob.ar/docs/Boletín Epidemio- Septiembre-N 2.pdf", category: "boletines-epidemiologicos" },
        { title: "Boletín Epidemiológico - Anual 2024", url: "https://salud.sanjuan.gob.ar/docs/BOLETIN EPIDEMIOLOGICO AÑO 2024-Publicacion  2025.pdf", category: "boletines-epidemiologicos" },
      ]
    };
  },
  mounted() {
    if (this.category) return;
    // Detectar el hash en la URL y activar el filtro correspondiente
    const hash = window.location.hash.replace('#', '');
    if (hash && this.filters.some(filter => filter.key === hash)) {
      this.activeFilter = hash;
    }
  },
  computed: {
    filteredPdfs() {
      if (this.activeFilter === 'todos') {
        return this.allPdfs;
      }
      return this.allPdfs.filter(pdf => pdf.category === this.activeFilter);
    }
  }
};
</script>

<style>
.info-general {
  width: 100%;
  max-width: 100vw;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  margin: 0 auto;
  overflow-x: hidden;
  box-sizing: border-box;
}

.info-general h4 {
  background-color: #ff6b35;
  color: white;
  padding: 15px 30px;
  margin: 0 auto 30px auto;
  border-radius: 8px;
  font-size: 1.3rem;
  font-weight: bold;
  width: auto;
  max-width: 900px;
  text-align: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  display: block;
}

.filter-tabs {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 6px;
  margin: 0 auto 40px auto;
  width: auto;
  max-width: 900px;
  border-radius: 8px;
  box-sizing: border-box;
}

.filter-tab {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  padding: 10px 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 600;
  color: #495057;
  flex: 0 1 auto;
  text-align: center;
  font-size: 14px;
  white-space: nowrap;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}



.filter-tab:hover {
  background-color: #e9ecef;
  transform: translateY(-1px);
}

.filter-tab.active {
  background-color: #ff6b35;
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(255, 107, 53, 0.3);
}

.pdf-grid-filtered {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  justify-content: center;
  justify-items: center;
  gap: 25px;
  width: 100%;
  max-width: 1200px;
  margin: 20px auto 0 auto;
  padding: 0 20px;
  box-sizing: border-box;
}

@media screen and (max-width: 768px) {
  .info-general {
    padding: 15px;
    min-height: auto;
    max-width: 100vw;
    overflow-x: hidden;
  }

  .info-general h4 {
    padding: 12px 20px;
    font-size: 1.1rem;
    margin: 0 auto 25px auto;
    max-width: calc(100vw - 30px);
    box-sizing: border-box;
  }

  .filter-tabs {
    max-width: calc(100vw - 30px);
    margin: 0 auto 30px auto;
    width: auto;
    gap: 6px;
  }

  .filter-tab {
    padding: 10px 16px;
    font-size: 13px;
    font-weight: 600;
  }

  .pdf-grid-filtered {
    grid-template-columns: 1fr;
    gap: 20px;
    padding: 0 15px;
    justify-content: center;
    max-width: calc(100vw - 30px);
  }
}

@media screen and (max-width: 600px) {
  .info-general {
    padding: 10px;
    max-width: 100vw;
    overflow-x: hidden;
  }

  .info-general h4 {
    padding: 10px 15px;
    font-size: 1rem;
    margin-bottom: 20px;
    max-width: calc(100vw - 20px);
  }

  .filter-tabs {
    max-width: calc(100vw - 20px);
    margin: 0 auto 30px auto;
    gap: 6px;
  }

  .filter-tab {
    padding: 10px 14px;
    font-size: 13px;
    flex: 0 1 auto;
  }

  .filter-tab:hover,
  .filter-tab.active {
    transform: none;
  }

  .pdf-grid-filtered {
    grid-template-columns: 1fr;
    gap: 15px;
    padding: 0 10px;
    justify-content: center;
    margin: 20px auto 0 auto;
    max-width: calc(100vw - 20px);
  }
}

@media screen and (max-width: 480px) {
  .info-general {
    padding: 8px;
    max-width: 100vw;
    overflow-x: hidden;
  }

  .filter-tabs {
    max-width: calc(100vw - 16px);
  }

  .filter-tab {
    padding: 12px 14px;
    font-size: 13px;
  }

  .pdf-grid-filtered {
    grid-template-columns: 1fr;
    gap: 12px;
    padding: 0 8px;
    max-width: calc(100vw - 16px);
  }
}

@media screen and (max-width: 360px) {
  .info-general {
    padding: 8px;
    max-width: 100vw;
    overflow-x: hidden;
  }

  .filter-tabs {
    max-width: calc(100vw - 16px);
  }

  .filter-tab {
    padding: 10px 12px;
    font-size: 12px;
  }

  .pdf-grid-filtered {
    grid-template-columns: 1fr;
    gap: 10px;
    padding: 0 8px;
    max-width: calc(100vw - 16px);
  }
}
</style>
